import React from 'react';
import classNames from 'classnames';

/**
 * Basket / shopping-cart icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to the component's own css
 * @param {string?} props.rootClassName overwrite the component's own css.root
 * @returns {JSX.Element} SVG cart icon
 */
const IconCart = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M3 3h2l.4 2M7 13h10l3-8H5.4M7 13L5.4 5M7 13l-2 4h13"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="9" cy="20" r="1.4" fill="currentColor" />
      <circle cx="17" cy="20" r="1.4" fill="currentColor" />
    </svg>
  );
};

export default IconCart;
